import errorsSchema from './errorsSchema';
import { ErrorsForm } from '../../../types/forms/form.def';

export const initErrorFields = (fields: Record<any, any>): ErrorsForm => {
  const errorObj = {};
  Object.keys(fields).forEach(field => {
    if (
      //si le champs est dans le schema d'erreur et que son champs presence est obligatoire ajouter au erreur probable
      errorsSchema[field] &&
      !errorsSchema[field]?.presence?.allowEmpty
    ) {
      Object.assign(errorObj, {
        [field]: true
      });
    }
  });
  return errorObj;
};
